import VueRouter, { Route } from 'vue-router';
import { Store } from 'vuex';
import { RootState, User } from 'frontend/types';
import { track } from 'frontend/utils/analytics';

const NUX_ROUTES = ['explorations_menu', 'explorations_topics', 'explorations_chapter'];

export function isActuallyNux(user: User, route: Route) {
  return (
    (user.is_in_nux || (route.query.tour && !user.is_classroom_student)) &&
    (!route.name || NUX_ROUTES.indexOf(route.name) >= 0)
  );
}

export function trackClickWithElementId(elementId: string) {
  track('ui', {
    action: 'click',
    element_id: elementId,
  });
}

export function trackModalWithElementId(elementId: string) {
  track('ui', {
    action: 'modal',
    element_id: elementId,
  });
}

export function trackPaymentActionWithId(actionId: string, extraData: { [key: string]: any } = {}) {
  const data = Object.assign({ action: actionId }, extraData);
  track('payment_action', data);
}

export async function handleClosedNuxPaywallForReturningUsers(
  store: Store<RootState>,
  router: VueRouter,
) {
  await router.push({ name: 'home' });
}
